







import Vue from 'vue'
import {
  slider,
  RenderPaginationHanlder,
  SliderOptions,
} from 'vue-concise-slider'
import SliderPaginationItem from './SliderPaginationItem.vue'

interface Data {
  sliderOptions: SliderOptions
}

export { slideritem as SliderItem } from 'vue-concise-slider'

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    slider,
    SliderPaginationItem,
  },
  data() {
    return {
      sliderOptions: {
        pagination: true,
        renderPagination: function(h: RenderPaginationHanlder, index: number) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const paginator = this as any
          return h(
            'slider-pagination-item',
            {
              class: 'slider-pagination-item',
              props: {
                index,
                currentPage: paginator.$parent.data.currentPage,
                sliderLength: paginator.$parent.s_data.sliderLength,
              },
            },
            [index],
          )
        },
      },
    }
  },
})
